import * as React from 'react';
import { useState } from 'react';
import SimpleTable from 'src/components/common/SimpleTable/SimpleTable';
import classNames from 'classnames';
import styles from '../assets/incentive-list.module.scss';
import DeleteIncentiveAction from './DeleteIncentiveAction';
import { Paginated } from 'src/services/api-handlers/pagination';
import { changeToZeroMoment } from 'src/helpers/timeHelpers';

import { IProvider } from 'src/types/provider';
import { IIncentive } from '../../../../../../../../../types/incentive';
import { Link } from 'react-router-dom';
import Router from '../../../../../../../../../navigation/router';
import { routes } from '../../../../../../../../../navigation';
import user from 'src/services/user-auth';
import UserRole from '../../../../../../../../../enumerables/user-role';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { numberWithCommas } from '../../../../../../../../../helpers/format';
import { QueryParams } from '../../../../../../../../../types/grid';

export interface StateProps {}
export interface DispatchProps {}

export interface OwnProps {
    provider: Partial<IProvider> | null;
    data: Paginated<IIncentive>;
    getData: (params: QueryParams) => void;
    month: { monthEnd: string; monthStart: string };
}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const IncentiveTable: React.FunctionComponent<Props> = ({ data, provider, month, getData }: Props) => {
    const [formColumn, setFormColumn] = useState<any>(false);
    const [openDrop] = useState<boolean>(false);
    const [currentDeChangeId, setId] = useState<string | number>(0);
    const dataSessionComponents: any = [];
    const { totalPages, page } = data;
    let totalAmount = 0;
    data.list.forEach((itSes: any) => {
        totalAmount += itSes.totalPaid ? +itSes.totalPaid : 0;

        dataSessionComponents.push({
            ...itSes,
            id: itSes.id,
            action: (
                <div className={styles.btnWrap}>
                    <Link
                        className={'btn ml-3 mr-1 btn-outline-info'}
                        to={Router.generate(routes.PROVIDER_DETAIL, {
                            id: itSes?.provider?.id,
                            tab: 'received-bonuses-detail',
                            subId: itSes.id,
                        })}
                    >
                        <FontAwesomeIcon icon={faSearch} />
                    </Link>
                    {user.getRoles().includes(UserRole.ROLE_ADMIN) ? (
                        <div className={classNames(styles.btnIn)}>
                            <DeleteIncentiveAction
                                getData={getData}
                                month={month}
                                provider={provider}
                                data={{ id: itSes.id }}
                            />
                        </div>
                    ) : null}
                </div>
            ),

            incentiveDate: itSes.incentiveDate ? changeToZeroMoment(itSes['incentiveDate'], 'MMM D, YYYY') : '',
            total: itSes.total ? `$${numberWithCommas(itSes.total)}` : '',
            periodStart: itSes.periodStart ? changeToZeroMoment(itSes['periodStart'], 'MMM D, YYYY') : '',
            periodEnd: itSes.periodEnd ? changeToZeroMoment(itSes['periodEnd'], 'MMM D, YYYY') : '',
        });
    });
    if (formColumn === true) {
    } else {
        if (totalAmount) {
            dataSessionComponents.push({
                total: `$${numberWithCommas(totalAmount)}`,
            });
        }
    }
    const isMobile = window.innerWidth <= 800;

    return (
        <div className={'d-flex flex-column'}>
            <div style={openDrop ? { overflow: 'visible' } : {}} className={'responsive-table'}>
                <SimpleTable
                    action={setFormColumn}
                    data={dataSessionComponents}
                    pagination={{ page, totalPages }}
                    columns={[
                        { id: 'action', label: 'Action', cellStyle: 'normal' },
                        /*    { id: 'id', label: '#', cellStyle: 'normal' },*/
                        { id: 'incentiveDate', label: 'Date', cellStyle: 'normal' },
                        { id: 'total', label: 'Total', cellStyle: 'normal' },
                        { id: 'periodStart', label: 'Start', cellStyle: 'normal' },
                        { id: 'periodEnd', label: 'End', cellStyle: 'normal' },
                    ]}
                />
            </div>
        </div>
    );
};

export default IncentiveTable;
